import { render } from "./ProjectsOrder.vue?vue&type=template&id=54263259"
import script from "./ProjectsOrder.vue?vue&type=script&lang=js"
export * from "./ProjectsOrder.vue?vue&type=script&lang=js"

import "./ProjectsOrder.vue?vue&type=style&index=0&id=54263259&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__